export default __webpack_public_path__ + "static/media/icon-input-visibility-on.5c094c50.svg";